export default "__VITE_ASSET__DGPeppvi__"